import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsClarisComponent } from './simple-icons-claris.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsClarisComponent ],
    exports:      [ SimpleIconsClarisComponent ],
    bootstrap:    []
})
export class SimpleIconsClarisModule {}
